import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { SharedPipesModule } from '../pipes/shared-pipes.module';

import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ListLegendComponent } from './list-legend/list-legend.component';
import { LoaderComponent } from './loader/loader.component';
import { Ng2FileDropComponent } from './ng2-file-drop/ng2-file-drop.component';
import { StarRatingComponent } from './star-rating/star-rating.component';

const components = [
	BtnLoadingComponent,
	Ng2FileDropComponent,
	LoaderComponent,
	StarRatingComponent,
	ListLegendComponent,
	ConfirmDialogComponent
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		SharedPipesModule,
		SharedDirectivesModule,
		PerfectScrollbarModule,
		NgbModule,
		FileUploadModule,
		MatDialogModule
	],
	declarations: components,
	exports: components
})
export class SharedComponentsModule {}
